import React from "react"
import {
  ButtonBase,
  BottomNavigationAction as MuiBottomNavigationAction,
} from "@mui/material"
import { IExtendedBottomNavigationActionProps } from "components/navigation/type"

export const ExtendedBottomNavigationAction: React.FC<
  IExtendedBottomNavigationActionProps
> = ({
  component = ButtonBase,
  onClick = () => {},
  backSideProps,
  ...restProps
}) => {
  return (
    <MuiBottomNavigationAction
      component={component}
      onClick={onClick}
      {...restProps}
    />
  )
}
